<template>
  <div class="d-flex flex-column flex-root">
    <div
      id="kt_login"
      class="login login-4 d-flex flex-row-fluid login-forgot-on"
      style="min-height: 100vh"
    >
      <div
        :style="{ backgroundImage: `url(${backgroundImage})` }"
        class="d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat"
      >
        <div
          class="login-form text-center p-7 position-relative overflow-hidden"
        >
          <!--begin::Login Header-->
          <div class="d-flex flex-center mb-15">
            <a href="#">
              <img
                alt=""
                class="max-h-75px"
                src="media/logos/logo-letter-13.png"
              />
            </a>
          </div>
          <!--end::Login Header-->

          <!--begin::Login forgot password form-->
          <div class="login-forgot">
            <div class="mb-20">
              <h3>{{ $t("resetPassword.header") }}</h3>
              <div class="text-muted font-weight-bold">
                {{ $t("resetPassword.header_text") }}
              </div>
            </div>
            <form
              id="kt_login_forgot_form"
              class="form"
              @submit.stop.prevent="onSubmit"
            >
              <div
                class="alert fade alert-danger" v-if="errors"
                role="alert"
                v-bind:class="{ show: errors }"
              >
                <div class="alert-text">
                  {{ errors }}
                </div>
              </div>

              <div
                class="alert fade alert-success" v-if="success_message && !errors"
                role="alert"
                v-bind:class="{ show: success_message }"
              >
                <div class="alert-text">
                  {{ success_message }}
                </div>
              </div>

              <div class="form-group mb-10">
                <b-form-input
                    ref="email"
                    v-model="form.email"
                    class="form-control h-auto form-control-solid py-4 px-8"
                    name="email"
                    :placeholder="$t('resetPassword.email')"
                    :state="validateState('email')"
                    type="email"
                />

                <b-form-invalid-feedback v-if="!validateState('email') && !$v.form.email.required" :state="!(validateState('email') && !$v.form.email.required)">
                  {{ $t('forgotPassword.validations.email.required') }}
                </b-form-invalid-feedback>

                <b-form-invalid-feedback v-else-if="!validateState('email') && !$v.form.email.email" :state="!(validateState('email') && !$v.form.email.email)">
                  {{ $t('forgotPassword.validations.email.email') }}
                </b-form-invalid-feedback>

              </div>

              <div class="form-group mb-10">
                <b-form-input
                    ref="email"
                    v-model="form.password"
                    class="form-control h-auto form-control-solid py-4 px-8"
                    name="email"
                    :placeholder="$t('resetPassword.password')"
                    :state="validateState('password')"
                    type="password"
                />
                <b-form-invalid-feedback v-if="!validateState('password') && !$v.form.password.required" :state="!(validateState('password') && !$v.form.password.required)">
                  {{ $t('resetPassword.validations.password.required') }}
                </b-form-invalid-feedback>

                <b-form-invalid-feedback v-else-if="!validateState('password') && !$v.form.password.passwordComplexity" :state="!(validateState('password') && !$v.form.password.passwordComplexity)">
                  {{ $t('resetPassword.validations.password.passwordComplexity') }}
                </b-form-invalid-feedback>
              </div>

              <div class="form-group mb-10">
                <b-form-input
                    ref="email"
                    v-model="form.password_confirmation"
                    class="form-control h-auto form-control-solid py-4 px-8"
                    name="email"
                    :placeholder="$t('resetPassword.password_confirmation')"
                    :state="validateState('password_confirmation')"
                    type="password"
                />

                <b-form-invalid-feedback v-if="!validateState('password_confirmation') && !$v.form.password_confirmation.sameAsPassword" :state="!(validateState('password_confirmation') && !$v.form.password_confirmation.sameAsPassword)">
                  {{ $t('resetPassword.validations.password_confirmation.same') }}
                </b-form-invalid-feedback>
              </div>
              <div class="form-group d-flex flex-wrap flex-center mt-10">
                <button
                    :disabled="disable"
                  id="kt_reset_password_submit"
                  ref="kt_reset_password_submit"
                  class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2"
                  type="submit"
                >
                  {{ $t("resetPassword.send") }}
                </button>
                <button
                  id="kt_login_forgot_cancel"
                  class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2"
                  type="button"
                  @click="$router.push({ name: 'login' })"
                >
                  {{ $t("resetPassword.cancel") }}
                </button>
              </div>
            </form>
          </div>
          <!--end::Login forgot password form-->
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/classic/login-4.scss";
</style>

<script>
import { mapState } from "vuex";
import { RESET_PASSWORD, LOGOUT } from "@/core/services/store/auth.module";
import moduleUser, {
  MODULE_NAME as MODULE_USER,
  SELF
} from "@/core/services/store/user.module";
import { validationMixin } from "vuelidate";
import { email, required, sameAs } from "vuelidate/lib/validators";
import store from "@/core/services/store";
import passwordComplexity from "@/assets/components/customValidators/passwordComplexity";

const _MODULE_USER = MODULE_USER;

export default {
  name: "ForgotPassword",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_USER, moduleUser);
  },
  data() {
    return {
      success_message: null,
      disable: false,
      form: {
        email: null,
        password: null,
        password_confirmation: null,
        token: null
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        passwordComplexity
      },
      password_confirmation: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  mounted() {
    if (this.user) {
      this.$router.push({ name: "dashboard" });
    }

    this.form.token = this.$route.params.token;
    if (!this.form.token) {
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-3.jpg";
    },
    user() {
      return this.$store.getters[_MODULE_USER + "/" + SELF];
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      let self = this;
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const form = this.form;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_reset_password_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // send login request
      this.$store.dispatch(RESET_PASSWORD, form ).then(response => {
        self.success_message = response;
        self.disable = true;
        setTimeout( () => this.$router.push({ name: 'login'}), 2000);
      });

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
    }
  },
  watch: {
    user(value) {
      if (value) {
        this.$router.push({ name: "dashboard" });
      }
    }
  }
};
</script>
